import { render, staticRenderFns } from "./NewMessageChatSummary.vue?vue&type=template&id=27ca4c0e&scoped=true"
import script from "./NewMessageChatSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewMessageChatSummary.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NewMessageChatSummary.vue?vue&type=style&index=0&id=27ca4c0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ca4c0e",
  null
  
)

export default component.exports